import React from 'react';
import { Star } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const CTASection: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="bg-blue-600 text-center">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8 lg:py-24">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
            Broker-carrier relationships made simple: One registration, multiple partners, zero compliance headaches.
          </h2>
          <p className="mt-4 text-lg leading-6 text-blue-100">
            Join brokers who streamline carrier onboarding and compliance with ease.
          </p>
        </div>

        {/* Trust Indicators - only show when not logged in */}
        {!isAuthenticated && (
          <div className="mt-10 mb-12">
            <div className="flex justify-center space-x-6">
              <div className="flex items-center">
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-current" />
                  ))}
                </div>
                <p className="ml-2 text-white">4.9/5 from 500+ reviews</p>
              </div>
            </div>
          </div>
        )}

        {/* CTA Buttons */}
        <div className="mt-8 flex justify-center space-x-4">
          {isAuthenticated ? (
            // Logged in - show dashboard button
            <a
              href="/dashboard"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50"
            >
              Go to Dashboard
            </a>
          ) : (
            // Not logged in - show trial and demo buttons
            <>
              <a
                href="/register/broker"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50"
              >
                Start Free Trial
              </a>
              <a
                href="https://www.youtube.com/watch?v=YOUR_VIDEO_ID"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 border border-white text-base font-medium rounded-md text-white hover:bg-blue-500"
              >
                Watch Demo
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CTASection;
